export const APP_STORE_URL =
  "https://apps.apple.com/us/app/lattice-app/id6756413550";

export const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.trylattice.railsmobile";
